<template>
  <nav
    role="navigation"
    aria-label="dropdown navigation"
  >
    <RouterLink
      class="navbar-item is-flex has-text-white"
      :to="{ name: 'Home' }"
    >
      <BIcon icon="poll-box" />
      <span>Facturación</span>
    </RouterLink>

    <RouterLink
      class="navbar-item is-flex has-text-white"
      :to="{ name: 'UsersList' }"
    >
      <BIcon icon="account-group" />
      <span>Usuarios</span>
    </RouterLink>
  </nav>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapMutations } = createNamespacedHelpers('ui');

export default {
  name: 'AppMenu',
  computed: {
    ...mapState({
      activeMenus: state => state.activeMenus,
    }),
  },
  methods: {
    ...mapMutations(['addActiveMenu']),
    ...mapMutations(['deleteActiveMenu']),
    activeMenu(menu) {
      if (this.activeMenus.includes(menu)) this.deleteActiveMenu(menu);
      else this.addActiveMenu(menu);
    },
  },
};
</script>

<style scoped>
.navbar-item,
.navbar-item.has-dropdown .navbar-link {
  padding: 0.75rem 1.75rem;
  cursor: pointer;
  text-transform: uppercase;
  position: relative;
}

.navbar-item.has-dropdown .navbar-link {
  width: 100%;
}

.navbar-item.has-dropdown {
  padding: 0;
}

.navbar-item .icon {
  padding-right: .5rem;
}

.navbar-item:hover span,
.navbar-item:hover .icon i {
  color: #39455B;
}

.navbar-item.router-link-exact-active {
  background: rgba(255, 255, 255, .1);
}

.navbar.is-primary .navbar-item.has-dropdown .navbar-link:hover {
  color: white;
}

.navbar.is-primary .navbar-item.has-dropdown.is-active .navbar-link,
.navbar.is-primary .navbar-item.has-dropdown.is-active .navbar-link {
  background: none;
}

.navbar.is-primary .navbar-item.has-dropdown:hover .navbar-link {
  background-color: #e8e8e8;
}

.navbar.is-primary .navbar-item.has-dropdown:hover .navbar-link .icon i,
.navbar.is-primary .navbar-item.has-dropdown:hover .navbar-link span {
  color: #39455B!important;
}

.navbar.is-primary .navbar-item.has-dropdown.is-active .navbar-link:not(.is-arrowless)::after {
  transform: rotate(135deg);
  top: 59%;
}

.navbar-dropdown a.navbar-item {
  padding-right: 0;
  padding-left: 2.5rem;
}

.navbar.is-primary .navbar-item.has-dropdown:hover a.navbar-item {
  color: white;
}

.navbar-item.has-dropdown:hover .navbar-item span,
.navbar-item.has-dropdown:hover .navbar-item .icon i {
  color: white;
}

.navbar-item.has-dropdown .navbar-item:hover span,
.navbar-item.has-dropdown .navbar-item:hover .icon i {
  color: #39455B;
}

@media screen and (min-width: 1088px){
  .navbar {
    flex-direction: column;
  }

  .navbar .navbar-dropdown {
    box-shadow: none;
    border-top: 0px;
    border-bottom: 0px;
  }

  .navbar-item.has-dropdown {
    flex-direction: column;
  }

  .navbar-dropdown {
    background: none;
    position: relative;

    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    border-left: 1px solid #dbdbdb;
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
